import {
    FaHtml5,
    FaCss3Alt,
    FaReact,
    FaNodeJs,
    FaGit,
    FaGithub,
    FaJsSquare,
  } from "react-icons/fa";
  import {
    SiMongodb,
    SiTypescript,
    SiNextdotjs,
    SiChakraui,
    SiSocketdotio,
    SiTailwindcss,
    SiCplusplus,
  } from "react-icons/si";
  
  export const technologies = [
    { id: 1, name: "HTML", icon: <FaHtml5 size={20} color="#E34F26" /> },
    { id: 2, name: "CSS", icon: <FaCss3Alt size={20} color="#1572B6" /> },
    { id: 3, name: "React", icon: <FaReact size={20} color="#61DAFB" /> },
    { id: 4, name: "Node.js", icon: <FaNodeJs size={20} color="#339933" /> },
    { id: 5, name: "MongoDB", icon: <SiMongodb size={20} color="#47A248" /> },
    { id: 6, name: "Next.js", icon: <SiNextdotjs size={20} color="#000" /> },
    { id: 7, name: "Chakra UI", icon: <SiChakraui size={20} color="#319795" /> },
    { id: 8, name: "Tailwind CSS", icon: <SiTailwindcss size={20} color="#38B2AC" /> },
    { id: 14, name: "Socket.IO", icon: <SiSocketdotio size={20} color="#000" /> },
    { id: 12, name: "TypeScript", icon: <SiTypescript size={20} color="#007ACC" /> },
    { id: 10, name: "GitHub", icon: <FaGithub size={20} color="#000" /> },
    { id: 11, name: "JavaScript", icon: <FaJsSquare size={20} color="#F7DF1E" /> },
    { id: 9, name: "Git", icon: <FaGit size={20} color="#F05032" /> },
    { id: 13, name: "C++", icon: <SiCplusplus size={20} color="#00599C" /> },
];
